// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"4e2ed90c","147":"48198676","210":"24b7ae51","574":"4354c3c8","807":"89e4cd5f","818":"415c0a00","900":"bbec8e99","996":"3a89255b"}[chunkId] + ".chunk.js";
};